export const CoverageTypeEnum = Object.freeze({
  EXTRA: 'extra',
  TOTAL: 'total',
  DISCOUNT: 'discount',
  SUBTOTAL: 'subtotal',
  COVER: 'cover',
});
